import { useState, useEffect, useContext } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import AppContext from "../contexts/appContext";
import { auth } from "../services/auth";
import Loader from "../shared/Loader";
import { Helmet } from "react-helmet";
import Select from "react-select";
import {
  validateUsername,
  validateTikTokUsername,
  validateYoutubeVideo,
  fetchTwitterProfile,
} from "../services/getStarted";
import styles from "../css/getStarted.module.css";

import ClientsReviewsSerivce from "../components/ClientsReviewsSerivce";

export default function GetStarted() {
  const { menu } = useContext(AppContext);

  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState("");
  const [error, setError] = useState("");
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedService, setSelectedService] = useState();
  const [selectedSubCategory, setSelectedSubCategory] = useState();
  const [selectedMenuItem, setSelectedMenuItem] = useState();
  const [selectedOption, setSelectedOption] = useState("none");

  const token = auth().getToken();
  const { serviceId, categoryId, subCategory, itemId, serviceItemId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const user = auth().getUser();

  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  const getSelectedSubCategory = (services) => {
    const selectedServiceLocal = services?.filter((ser) => ser.id == serviceId)[0];
    const subcatergories = selectedServiceLocal?.category?.filter((cat) => cat.id == categoryId)[0]
      ?.subcategory;
    const selectedSubCat = subcatergories?.filter((subCat) => subCat.id == subCategory)[0];
    const selectedItem = selectedSubCat?.menuItem?.filter((item) => item.id == itemId)[0];
    setSelectedService(selectedServiceLocal);
    setSelectedSubCategory(selectedSubCat);
    setSelectedMenuItem(selectedItem);
    return selectedSubCat;
  };

  const changeServiceItem = (valServiceItem) => {
    setSelectedOption(valServiceItem);
    navigate(
      `/getstarted/${selectedService.name.toLowerCase()}/${serviceId}/${categoryId}/${subCategory}/${valServiceItem}/${serviceItemId}`
    );
    return null;
  };

  useEffect(() => {
    setSelectedOption(selectedMenuItem?.id);
  }, [selectedMenuItem]);

  useEffect(() => {
    localStorage.removeItem("selectedService");
    if (user != null && user != undefined) {
      setEmail(user.email);
    }
    if (menu?.length) {
      if (location.pathname === "/getstarted") {
        const service = menu[0];
        const category = service?.category[0];
        const subcategory = category.subcategory[0];
        navigate(
          `/getstarted/${service?.name.toLowerCase()}/${service?.id}/${category.id}/${
            subcategory.id
          }/${subcategory.menuItem[0].id}/${subcategory.itemId}`
        );
      }
      getSelectedSubCategory(menu);
    }
  }, [location, menu]);

  const checkInstaUsername = async (username) => {
    const regexPattern = /^(?!.*\.\.)(?!.*\.$)[^\W][\w.]{0,29}$/i;
    if (!regexPattern.test(username)) {
      setError("Invalid Instagram Username.");
      setIsLoading(false);
      return false;
    }
    return validateUsername(username, config)
      .then((response) => {
        if (response.data?.error_code === "INVALID_USERNAME") {
          setError("Invalid Instagram Username.");
          return false;
        } else {
          localStorage.setItem("InstaData", JSON.stringify(response.data));
          return true;
        }
      })
      .catch((error) => {
        setHasError(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  //FB
  const checkFacebookPage = async (username) => {
    const regexPattern = new RegExp("^https?://(?:www.)?facebook.com/([^/?]+)/?$");
    if (!regexPattern.test(username)) {
      setError("Invalid Facebook Page Link");
      setIsLoading(false);
      return false;
    }
    return true;
  };
  const checkFacebookPosts = async (username) => {
    const regexPattern = new RegExp("^https?://(?:www.)?facebook.com/([^/?]+)/posts/([^/?]+)/?$");
    if (!regexPattern.test(username)) {
      setError("Invalid Facebook Post Link");
      setIsLoading(false);
      return false;
    }
    return true;
  };
  const checkFacebookSite = async (username) => {
    const regexPattern = new RegExp("^(https?://)?((w{3}.)?)facebook.com/.*");
    if (!regexPattern.test(username)) {
      setError("Invalid Facebook Link");
      setIsLoading(false);
      return false;
    }
    return true;
  };

  //TWITTER
  const checkTwitterUser = async (username) => {
    return fetchTwitterProfile(username, config)
      .then((response) => {
        if (response.status === 200) {
          localStorage.setItem("TwitterData", JSON.stringify(response.data));
          return true;
        } else {
          setError("Invalid Twitter username");
          setIsLoading(false);
          return false;
        }
      })
      .catch((error) => {
        setHasError(true);
        return false;
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  //Youtube
  const checkYoutubeSite = async (username, contentType) => {
    const regexPattern = new RegExp("^(https?://)?((w{3}.)?)youtube.com/.*");
    if (!regexPattern.test(username)) {
      setError("Invalid channel URL!");
      setIsLoading(false);
      return false;
    }
    return validateYoutubeVideo(username, config)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.contentType !== contentType) {
            setError("Invalid channel or video URL");
            setIsLoading(false);
            return false;
          }
          localStorage.setItem("YoutubeData", JSON.stringify(response.data));
          return true;
        } else {
          setError("Invalid channel URL");
          setIsLoading(false);
          return false;
        }
      })
      .catch((error) => {
        setHasError(true);
        return false;
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const checkSoundCloud = async (username) => {
    const regexPattern = new RegExp("^https?://(soundcloud.com|snd.sc)/(.*)$");
    if (!regexPattern.test(username)) {
      setError("Invalid Soundcloud username URL");
      setIsLoading(false);
      return false;
    }
    setIsLoading(false);
    return true;
  };
  const checkSoundCloudTrack = async (username) => {
    const regexPattern = new RegExp("^https?://(?:www.)?soundcloud.com/(?:[^/]+/)+[^/]+$");
    if (!regexPattern.test(username)) {
      setError("Invalid Soundcloud Track URL");
      setIsLoading(false);
      return false;
    }
    setIsLoading(false);
    return true;
  };

  //TikTok
  const checkTikTokUsername = async (username) => {
    return validateTikTokUsername(username, config)
      .then((response) => {
        if (response.status === 200) {
          localStorage.setItem("TikTokData", JSON.stringify(response.data));
          return true;
        } else {
          setError("Invalid TIKTOK profile");
          setIsLoading(false);
          return false;
        }
      })
      .catch((error) => {
        setHasError(true);
        return false;
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    localStorage.setItem("email", JSON.stringify(email));
    switch (selectedSubCategory.nameOfService) {
      case "InstaDefault":
      case "InstaImages":
      case "InstaComments":
      case "InstaCustomComments":
      case "InstaVideo":
        if (await checkInstaUsername(username)) {
          setError("");
          navigate(
            `/posts/${encodeURIComponent(
              username
            )}/${email}/${serviceId}/${categoryId}/${subCategory}/${itemId}/${serviceItemId}/`
          );
        }
        break;
      case "FacebookPage":
        if (await checkFacebookPage(username)) {
          setError("");
          navigate(
            `/posts/${encodeURIComponent(
              username
            )}/${email}/${serviceId}/${categoryId}/${subCategory}/${itemId}/${serviceItemId}/`
          );
        }
        break;
      case "FacebookPosts":
        if (await checkFacebookPosts(username)) {
          setError("");
          navigate(
            `/posts/${encodeURIComponent(
              username
            )}/${email}/${serviceId}/${categoryId}/${subCategory}/${itemId}/${serviceItemId}/`
          );
        }
        break;
      case "FacebookComment":
      case "FacebookCustomComment":
      case "FacebookDefault":
      case "FacebookProfile":
        if (await checkFacebookSite(username)) {
          setError("");
          navigate(
            `/posts/${encodeURIComponent(
              username
            )}/${email}/${serviceId}/${categoryId}/${subCategory}/${itemId}/${serviceItemId}/`
          );
        }
        break;
      case "TwitterFollow":
      case "TwitterPost":
        if (await checkTwitterUser(username)) {
          setError("");
          navigate(
            `/posts/${encodeURIComponent(
              username
            )}/${email}/${serviceId}/${categoryId}/${subCategory}/${itemId}/${serviceItemId}/`
          );
        }
        break;
      case "YoutubeVideo":
      case "YoutubeCustomComments":
      case "YoutubeChannel":
        if (
          await checkYoutubeSite(
            username,
            selectedSubCategory.nameOfService == "YoutubeChannel" ? "channel" : "video"
          )
        ) {
          setError("");
          navigate(
            `/posts/${encodeURIComponent(
              username
            )}/${email}/${serviceId}/${categoryId}/${subCategory}/${itemId}/${serviceItemId}/`
          );
        }
        break;
      case "SoundCloudArtist":
        if (await checkSoundCloud(username)) {
          setError("");
          navigate(
            `/posts/${encodeURIComponent(
              username
            )}/${email}/${serviceId}/${categoryId}/${subCategory}/${itemId}/${serviceItemId}/`
          );
        }
        break;
      case "SoundCloudTrack":
        if (await checkSoundCloudTrack(username)) {
          setError("");
          navigate(
            `/posts/${encodeURIComponent(
              username
            )}/${email}/${serviceId}/${categoryId}/${subCategory}/${itemId}/${serviceItemId}/`
          );
        }
        break;
      case "TikTokProfile": // TikTokComments,  TikTokRandomComments
      case "TikTokComments":
      case "TikTokCustomComments":
        if (await checkTikTokUsername(username)) {
          setError("");
          navigate(
            `/posts/${encodeURIComponent(
              username
            )}/${email}/${serviceId}/${categoryId}/${subCategory}/${itemId}/${serviceItemId}/`
          );
        }
        break;
      case "TikTokPost":
        if (await checkTikTokUsername(username)) {
          setError("");
          navigate(
            `/posts/${encodeURIComponent(
              username
            )}/${email}/${serviceId}/${categoryId}/${subCategory}/${itemId}/${serviceItemId}/`
          );
        }
        break;
      default:
        break;
    }
  };

  const formatOptionLabel = ({ name, id, price }) => (
    <div key={id} className="flex flex-row gap-2 justify-between">
      <div>{name}</div>
      <div>${price}</div>
    </div>
  );

  const style = {
    control: (base) => ({
      ...base,
      border: 0,
      // This line disables the blue border
      boxShadow: "none",
    }),
    singleValue: (base) => ({
      ...base,
      height: "100%",
      color: "#962fbf",
      paddingTop: "3px",
    }),
  };

  return (
    <section className="bg-gradient-to-r from-gray-300/10 via-gray-300/25 to-pink-350/25 relative overflow-x-hidden">
      <Helmet>
        <title>
          Dailysocialboost |{" "}
          {selectedService
            ? `Buy ${selectedService?.name} - ${selectedSubCategory?.name}`
            : `Get Started`}
        </title>
      </Helmet>
      <div className="container mx-auto py-32 px-24 flex flex-col lg:flex-row gap-32">
        <div className="basis-1/2">
          <h2 className="text-5xl font-bold my-10">
            {selectedService
              ? `Buy ${selectedService?.name} - ${selectedSubCategory?.name}`
              : `Get Started`}
          </h2>
          <form onSubmit={handleSubmit} className="flex flex-col">
            <div className="my-5">
              <div>
                <label className="uppercase font-semibold" htmlFor="username">
                  Username
                </label>
              </div>
              <input
                className={`px-2 transition ease-in-out hover:border-b-pink-500 hover:border-b-2 h-12 rounded-xl w-full bg-white outline-0 border border-transparent`}
                type="text"
                placeholder={selectedSubCategory?.placeholderText}
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                name="username"
                id="username"
                required
              />
            </div>
            <div className="my-5">
              <div>
                <label className="uppercase font-semibold" htmlFor="email">
                  Email Address
                </label>
              </div>
              <input
                placeholder="Email"
                className={`px-2 transition ease-in-out hover:border-b-2 h-12 rounded-xl w-full  outline-0 border border-transparent ${
                  !user ? "bg-white hover:border-b-pink-500" : "bg-gray-100"
                }`}
                type="email"
                disabled={user ? "disabled" : ""}
                value={user != null && user != undefined ? user.email : email}
                onChange={(e) => setEmail(e.target.value)}
                name="email"
                id="email"
                required
              />
            </div>
            <div className="my-5 flex flex-col gap-2 text-center justify-center self-center z-10">
              <div className="flex flex-col">
                {selectedSubCategory ? (
                  <Select
                    onChange={(e) => changeServiceItem(e.id)}
                    className=" border w-96 px-1 py-1 rounded-xl bg-white border-gray-300 hover:border-purple-650 hover:border-5 text-purple-650  focus:border-purple-650 block z-10"
                    formatOptionLabel={formatOptionLabel}
                    options={
                      selectedSubCategory?.menuItem
                        ? selectedSubCategory.menuItem.sort((a, b) => a.id - b.id)
                        : null
                    }
                    getOptionValue={(option) => option.id}
                    placeholder={"Select value!"}
                    styles={style}
                    value={selectedSubCategory?.menuItem?.filter(function (option) {
                      return option.id === selectedOption;
                    })}
                  />
                ) : null}
              </div>
              <div>Starts in 12 hours!</div>
            </div>
            {/* <div className="my-5">
							<input className="mr-3" type="checkbox" value={consent} onChange={e => setConsent(e.target.value)} name="consent" id="consent" />
							<label htmlFor="consent">Send me special promotions and discounts</label>
							<br />
						</div> */}
            <div className="my-5 self-center">
              <button
                className={`mx-2 my-3 px-20 py-3 self-center ${styles.continueButton}`}
                type="submit"
                value="Continue"
              >
                Continue
              </button>
              {isLoading ? (
                <div className="my-5 mx-20">
                  {" "}
                  <Loader styles={"w-8 h-8"}></Loader>{" "}
                </div>
              ) : hasError ? (
                <p className="text-xl text-red-600">Failed validating, please try again! </p>
              ) : null}
              {error ? (
                <div
                  className="flex p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400"
                  role="alert"
                >
                  <svg
                    aria-hidden="true"
                    className="flex-shrink-0 inline w-5 h-5 mr-3"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                  <div>
                    <span className="font-medium">Error!</span> {error}
                  </div>
                </div>
              ) : null}
            </div>
          </form>
        </div>
        <div className="basis-1/2 self-center">
          <div className="lg:max-w-2xl sm:max-w-xs md:max-w-sm">
            <div className="container mx-auto">
              <ClientsReviewsSerivce />
            </div>
          </div>
        </div>
      </div>
      <div className="bottom-triangle-left relative align-bottom"></div>
      <div className="bottom-triangle-right-purple absolute align-bottom"></div>
    </section>
  );
}
